module.exports = __webpack_public_path__ + "static/media/overflow.b9abb87f.svg";